import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'stack', 'IconStack', [["path",{"d":"M12 6l-8 4l8 4l8 -4l-8 -4","key":"svg-0"}],["path",{"d":"M4 14l8 4l8 -4","key":"svg-1"}]]);